import { useTranslation } from 'react-i18next';
import { Modal, ProgressBar } from '@teo/components';
import { useState, useEffect, useRef } from 'react';
import { Portal } from '@/components/Portal';
import { uploadFileInstruction, uploadFile } from '@/query/documents';

export const VideoUploadModalInstruction = ({
  setIsOpenVideoUploadModal,
  isOpenVideoUploadModal,
  newUploadFile,
  state,
  setNewState,
}) => {
  const { t } = useTranslation();
  const [uploadProgress, setUploadProgress] = useState(0);
  const uploadVideoRef = useRef(null);

  const closeModal = () => {
    (async () => {
      setIsOpenVideoUploadModal(!isOpenVideoUploadModal);
    })();
  };

  const uploadeVideo = async (file) => {
    if (!file) return;

    (async () => {
      try {
        const uploadUrl = await uploadFileInstruction(
          '/instruction_uploads',
          file,

          {
            fireAndForget: false,
            onProgress: (progress) => {
              setUploadProgress(progress);
            },
          }
        );

        const widgetState = {
          titleWidget: 'Instruction',
          url: uploadUrl,
          title: t('pages.create_edit_course.new_instruction_title'),
        };

        await setNewState({ ...state, ...widgetState });
        setIsOpenVideoUploadModal(false);
      } catch (err) {
        console.error('Failed to upload instruction video', err);
      }
    })();
  };

  useEffect(() => {
    if (newUploadFile) {
      uploadeVideo(newUploadFile);
    }
  }, [newUploadFile]);

  useEffect(() => {
    if (!newUploadFile) return;

    const checkAndSet = () => {
      const video = uploadVideoRef.current;
      if (!video) {
        requestAnimationFrame(checkAndSet); // ✨ повтор до появи
        return;
      }
      const localUrl = URL.createObjectURL(newUploadFile);
      video.src = localUrl;
      video.controls = true;
      video.load();
    };

    checkAndSet();
  }, [newUploadFile]);

  useEffect(() => {
    if (!isOpenVideoUploadModal) {
      setUploadProgress(0);
    }
  }, [isOpenVideoUploadModal]);

  return (
    <Portal root="body">
      <div className="z-10 bg-white">
        <Modal isOpen={isOpenVideoUploadModal}>
          <Modal.Header onClose={closeModal}>
            {t('pages.create_edit_course.video_instruction.title_upload')}
          </Modal.Header>
          <Modal.Body>
            <div className="max-h-[70vh] overflow-hidden">
              <video
                ref={uploadVideoRef}
                controls
                style={{
                  minWidth: '100%',
                  minHeight: '100%',
                  maxWidth: '100%',
                  maxHeight: '65vh',
                  objectFit: 'contain',
                }}
              ></video>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className="mt-6 flex w-full flex-col gap-6">
              <div className="text-sm font-medium text-black">
                {uploadProgress === 100
                  ? t('pages.create_edit_course.video_instruction.ready_upload')
                  : t(
                      'pages.create_edit_course.video_instruction.proces_upload'
                    )}
              </div>
              <div className="flex w-full flex-row items-center gap-2">
                <ProgressBar
                  max={100}
                  value={uploadProgress}
                  className={` h-1 overflow-hidden rounded-lg ${
                    uploadProgress === 100 && 'progress-bar__all'
                  }`}
                />
                <span className="pl-3 text-xs text-grey-06">
                  {uploadProgress}%
                </span>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </Portal>
  );
};
